import React from 'react';
import { motion } from 'framer-motion';
import { 
  TrendUp, 
  Users, 
  Shield, 
  Rocket, 
  Globe, 
  Target,
} from '@phosphor-icons/react';

const PartnerBenefits = () => {
  const benefits = [
    {
      icon: <TrendUp className="w-8 h-8" weight="thin" />,
      title: "Per Klant Commissie",
      description: "Verdien €200 - €1,000 per klant die je aanbrengt. Hoe beter de klant, hoe hoger je beloning.",
      color: "from-blue-600 to-indigo-700",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-200"
    },
    {
      icon: <Users className="w-8 h-8" weight="thin" />,
      title: "Geen Verplichtingen",
      description: "Je hoeft geen partner te worden. Breng gewoon klanten aan en verdien direct na oplevering.",
      color: "from-blue-700 to-indigo-800",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-200"
    },
    {
      icon: <Shield className="w-8 h-8" weight="thin" />,
      title: "Direct Uitbetaald",
      description: "Geen maandelijkse betalingen. Krijg je commissie direct na oplevering van de klant.",
      color: "from-indigo-700 to-blue-800",
      bgColor: "bg-indigo-50",
      borderColor: "border-indigo-300"
    },
    {
      icon: <Rocket className="w-8 h-8" weight="thin" />,
      title: "Simpel Systeem",
      description: "Geen complexe programma's of niveaus. Gewoon klanten aanbrengen en verdienen.",
      color: "from-blue-800 to-indigo-900",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-300"
    },
    {
      icon: <Globe className="w-8 h-8" weight="thin" />,
      title: "Wereldwijde Kansen",
      description: "Onze diensten zijn geschikt voor klanten wereldwijd. Vergroot je markt en verdien meer.",
      color: "from-indigo-800 to-blue-900",
      bgColor: "bg-indigo-50",
      borderColor: "border-indigo-400"
    },
    {
      icon: <Target className="w-8 h-8" weight="thin" />,
      title: "Flexibele Aanpak",
      description: "Werk op je eigen tempo. Geen druk, alleen kansen om te verdienen.",
      color: "from-blue-900 to-indigo-950",
      bgColor: "bg-blue-50",
      borderColor: "border-blue-400"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-full px-4 py-2 mb-6">
            <TrendUp className="w-5 h-5" weight="thin" />
            <span className="text-sm font-medium">Hoe het Verdienmodel Werkt</span>
          </div>
          
          <h2 className="text-3xl lg:text-5xl font-bold text-gray-900 mb-6">
            Simpel verdienen door{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-700">
              klanten aan te brengen
            </span>
          </h2>
          
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Geen complexe programma's of verplichtingen. Breng gewoon klanten aan en verdien direct na oplevering.
          </p>
        </motion.div>

        {/* Benefits Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid md:grid-cols-2 lg:grid-cols-3 gap-8"
        >
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className={`relative p-8 rounded-2xl ${benefit.bgColor} border ${benefit.borderColor} hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2`}
            >
              {/* Icon */}
              <div className={`w-16 h-16 bg-gradient-to-r ${benefit.color} rounded-2xl flex items-center justify-center text-white mb-6`}>
                {benefit.icon}
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {benefit.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>

              {/* Hover Effect */}
              <div className={`absolute inset-0 bg-gradient-to-r ${benefit.color} opacity-0 hover:opacity-5 rounded-2xl transition-opacity duration-300`} />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default PartnerBenefits;
